import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  readonly distLocation: string = 'office/';

  constructor() { }
}
